




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { emptyText, loadingText } from '@/utils/constants';

// 小组件的通用数据表格
@Component
export default class HomeWidgetDataTable extends Vue {
  @Prop() public title!: string;
  @Prop() public headers!: any[];
  @Prop({ type: Array, default: () => [] }) public items!: any[];
  @Prop({ type: Boolean, default: false }) public loading!: boolean;

  public emptyText =  emptyText;
  public loadingText = loadingText;
}
